import { render, staticRenderFns } from "./RuleCustomEditPrice.vue?vue&type=template&id=4a7f569d&scoped=true"
import script from "./RuleCustomEditPrice.vue?vue&type=script&lang=js"
export * from "./RuleCustomEditPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7f569d",
  null
  
)

export default component.exports